import { createSlice } from "@reduxjs/toolkit";
import { getCustomerList } from "../utilsReduxApi/getCustomerList";
import { getCollectionList } from "../utilsReduxApi/getCollectionList";
import { getProductList } from "../utilsReduxApi/getProductList";
import { getTages } from "../utilsReduxApi/getTages";

const UtilsSlice = createSlice({
  name: "utils",
  initialState: {
    customerList: [],
    categoryList: [],
    productList: [],
    tageList: [],
    getCategory: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCustomerList.fulfilled, (state, action) => {
      state.customerList = action.payload.data.customer;
    });
    builder.addCase(getCollectionList.fulfilled, (state, action) => {
      state.categoryList = action.payload.data.response;
    });
    builder.addCase(getProductList.fulfilled, (state, action) => {
      // console.log("action.payload", action.payload);
      state.productList = action.payload.data.response;
      // console.log(state.clientList);
    });
    builder.addCase(getTages.fulfilled, (state, action) => {
      state.tageList = action.payload.data.response;
    });
  },
});

export default UtilsSlice.reducer;
